// Static UI configuration. Admin credentials are NOT stored here.
// Authentication is handled by /api/auth/login + JWT in AuthContext.

export const BRAZO_INFO = {
  length: '30 cm',
  servings: '10-12 porciones',
  description: 'Cada brazo gitano completo mide aproximadamente 30 cm y rinde para 10-12 porciones generosas'
};
